import { render, staticRenderFns } from "./ContractRelatedMatters.vue?vue&type=template&id=4a21b43e&scoped=true"
import script from "./ContractRelatedMatters.vue?vue&type=script&lang=js"
export * from "./ContractRelatedMatters.vue?vue&type=script&lang=js"
import style0 from "./ContractRelatedMatters.vue?vue&type=style&index=0&id=4a21b43e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a21b43e",
  null
  
)

export default component.exports